export const PROJECT_SETTINGS_KEYS = {
  showOpinionQuestionsInSurvey: "opinion-show",
};
